var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3266 8.33203H5.04167L11.1975 2.98828C11.296 2.90215 11.2362 2.74219 11.1061 2.74219H9.55046C9.48191 2.74219 9.41687 2.7668 9.36589 2.81074L2.72312 8.57461C2.66228 8.62735 2.61349 8.69255 2.58004 8.76579C2.5466 8.83903 2.5293 8.91861 2.5293 8.99912C2.5293 9.07964 2.5466 9.15921 2.58004 9.23245C2.61349 9.3057 2.66228 9.37089 2.72312 9.42363L9.40456 15.2227C9.43093 15.2455 9.46257 15.2578 9.49597 15.2578H11.1044C11.2344 15.2578 11.2942 15.0961 11.1958 15.0117L5.04167 9.66797H15.3266C15.404 9.66797 15.4673 9.60469 15.4673 9.52734V8.47266C15.4673 8.39531 15.404 8.33203 15.3266 8.33203Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.759681429adead0366acf19c27c85ff9.svg";
export { ForwardRef as ReactComponent };